import AppRouter from "./router/AppRouter";
import ErrorBoundary from "./components/ErrorBoundary";
import { BrandingProvider } from "./utils/BrandingContext";

function App() {
  return (
    <BrandingProvider>
      <ErrorBoundary>
        <AppRouter />
      </ErrorBoundary>
    </BrandingProvider>
  );
}

export default App;
